import React from 'react';
import { Link } from 'react-router-dom';
import ServicePageLayout from '../layouts/ServicePageLayout';
import TestimonialCard from '../components/TestimonialCard';
import DetailedProcess from '../components/DetailedProcess';
import SupportHero from '../components/SupportHero/SupportHero';
import ContactBanner from '../components/ContactBanner/ContactBanner';
import { useTranslation } from 'react-i18next';

const SupportAndOptimizationPage = () => {
  const { t } = useTranslation();
  
  const title = t('supportPage.title');
  const subtitle = t('supportPage.subtitle');

  const combinedFeatures = [
    { key: 'help' },
    { key: 'audit' },
    { key: 'maintenance' },
    { key: 'planning' },
  ].map(feature => ({
    title: t(`supportPage.features.${feature.key}.title`),
    description: t(`supportPage.features.${feature.key}.description`),
  }));

  const supportProcessSteps = [
    { key: 'assessment' },
    { key: 'plan' },
    { key: 'implementation' },
    { key: 'verification' },
  ].map(step => ({
    title: t(`supportPage.supportProcess.steps.${step.key}.title`),
    description: t(`supportPage.supportProcess.steps.${step.key}.description`),
  }));

  return (
    <>
      <SupportHero title={title} subtitle={subtitle} />
      <ServicePageLayout
        title={title}
        subtitle={subtitle}
        features={combinedFeatures}
        hideHero={true}
      >
        <div className="space-y-20">
          {/* IT Support Section */}
          <section className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-10 text-center">{t('supportPage.supportProcess.title')}</h2>
            <DetailedProcess steps={supportProcessSteps} />
          </section>
        </div>

        <ContactBanner 
            title={t('supportPage.contactBanner.title')}
            description={t('supportPage.contactBanner.description')}
            buttonText={t('supportPage.contactBanner.buttonText')}
            buttonLink="/start-your-project"
        />
      </ServicePageLayout>
    </>
  );
};

export default SupportAndOptimizationPage; 